export default __webpack_public_path__ + "static/hodler_tablet-5e225423c4af1f424381357625d0b086.png";